import React, { useState } from 'react';

const INITIAL_PAGES = [
  { id:1, name:'Club Sign-up Landing Page', status:'Published', url:'transferexpo.com/clubs/join', views:2840, submissions:312, conversion:'11%', created:'Jan 15, 2026', form:'Club Sign-up Form', template:'Hero + Form' },
  { id:2, name:'Scout Recruitment Page',    status:'Published', url:'transferexpo.com/scouts/apply', views:1420, submissions:187, conversion:'13%', created:'Jan 20, 2026', form:'Scout Application Form', template:'Split layout' },
  { id:3, name:'West Africa Showcase RSVP', status:'Published', url:'transferexpo.com/events/waf2026', views:680, submissions:42, conversion:'6%', created:'Mar 1, 2026', form:'Event RSVP Form', template:'Event' },
  { id:4, name:'Premium Upsell Page',       status:'Draft',     url:'—', views:0, submissions:0, conversion:'—', created:'Apr 1, 2026', form:'None', template:'Product' },
];

const TEMPLATES = [
  { id:'hero',    name:'Hero + Form',    desc:'Large headline with form on the right' },
  { id:'split',   name:'Split layout',   desc:'50/50 content and form' },
  { id:'event',   name:'Event page',     desc:'Date, location, agenda + RSVP' },
  { id:'product', name:'Product/Upsell', desc:'Features, pricing, CTA' },
  { id:'minimal', name:'Minimal',        desc:'Clean, distraction-free form page' },
];

const statusBadge = s => s === 'Published' ? 'badge badge-green' : s === 'Draft' ? 'badge badge-gray' : 'badge badge-amber';

export default function LandingPages({ toast }) {
  const [pages, setPages]       = useState(INITIAL_PAGES);
  const [creating, setCreating] = useState(false);
  const [step, setStep]         = useState(1);
  const [newPage, setNewPage]   = useState({ name:'', template:'hero', form:'Club Sign-up Form', headline:'', subheadline:'', cta:'Get started' });

  const createPage = () => {
    if (!newPage.name) { toast?.('Enter a page name', 'warning'); return; }
    const p = {
      id: Date.now(), name: newPage.name, status:'Draft',
      url:'—', views:0, submissions:0, conversion:'—',
      created: new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}),
      form: newPage.form, template: TEMPLATES.find(t=>t.id===newPage.template)?.name || newPage.template,
    };
    setPages(prev=>[...prev,p]);
    setCreating(false); setStep(1);
    setNewPage({ name:'', template:'hero', form:'Club Sign-up Form', headline:'', subheadline:'', cta:'Get started' });
    toast?.('Landing page created as draft');
  };

  const publish = id => {
    setPages(prev=>prev.map(p=>p.id===id?{...p,status:'Published',url:`transferexpo.com/p/${id}`}:p));
    toast?.('Page published!');
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total pages</div><div className="stat-value">{pages.length}</div><div className="stat-sub">All pages</div></div>
        <div className="stat-card"><div className="stat-label">Published</div><div className="stat-value">{pages.filter(p=>p.status==='Published').length}</div><div className="stat-sub stat-up">Live</div></div>
        <div className="stat-card"><div className="stat-label">Total views</div><div className="stat-value">{pages.reduce((s,p)=>s+p.views,0).toLocaleString()}</div><div className="stat-sub">All pages</div></div>
        <div className="stat-card"><div className="stat-label">Total submissions</div><div className="stat-value">{pages.reduce((s,p)=>s+p.submissions,0).toLocaleString()}</div><div className="stat-sub stat-up">Form fills</div></div>
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
        <h3 style={{ fontFamily:'var(--font-display)', fontSize:16, fontWeight:500, color:'var(--text-primary)' }}>Landing pages</h3>
        <button className="btn btn-primary" onClick={()=>setCreating(true)}>+ Create page</button>
      </div>

      {creating && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header">
            <span className="card-title">Create landing page — Step {step} of 2</span>
            <button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>{ setCreating(false); setStep(1); }}>✕</button>
          </div>
          {step === 1 && (
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:6, fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Page name *</label>
                <input className="search-input" placeholder="e.g. Club Recruitment Page" value={newPage.name} onChange={e=>setNewPage(p=>({...p,name:e.target.value}))} />
              </div>
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:10, fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Choose template</label>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10 }}>
                  {TEMPLATES.map(t=>(
                    <div key={t.id} onClick={()=>setNewPage(p=>({...p,template:t.id}))}
                      style={{ padding:'14px', borderRadius:10, border:`2px solid ${newPage.template===t.id?'var(--accent)':'var(--border)'}`, cursor:'pointer', background:newPage.template===t.id?'rgba(167,244,50,0.05)':'var(--bg-input)' }}>
                      <div style={{ fontWeight:600, fontSize:13, color:newPage.template===t.id?'var(--accent)':'var(--text-primary)', marginBottom:4 }}>{t.name}</div>
                      <div style={{ fontSize:11, color:'var(--text-dim)' }}>{t.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
              <button className="btn btn-primary" style={{ alignSelf:'flex-start' }} onClick={()=>setStep(2)}>Next →</button>
            </div>
          )}
          {step === 2 && (
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                <div>
                  <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:6, fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Headline</label>
                  <input className="search-input" placeholder="e.g. Join TransferExpo as a Club" value={newPage.headline} onChange={e=>setNewPage(p=>({...p,headline:e.target.value}))} />
                </div>
                <div>
                  <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:6, fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>CTA button text</label>
                  <input className="search-input" value={newPage.cta} onChange={e=>setNewPage(p=>({...p,cta:e.target.value}))} />
                </div>
              </div>
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:6, fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Sub-headline</label>
                <input className="search-input" placeholder="Supporting description..." value={newPage.subheadline} onChange={e=>setNewPage(p=>({...p,subheadline:e.target.value}))} />
              </div>
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:6, fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px' }}>Connected form</label>
                <select className="search-input" value={newPage.form} onChange={e=>setNewPage(p=>({...p,form:e.target.value}))}>
                  {['Club Sign-up Form','Scout Application Form','Contact Us Form','Event RSVP Form','None'].map(f=><option key={f}>{f}</option>)}
                </select>
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button className="btn btn-ghost" onClick={()=>setStep(1)}>← Back</button>
                <button className="btn btn-primary" onClick={createPage}>Create page</button>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Page name</th><th>Template</th><th>URL</th><th>Views</th><th>Submissions</th><th>Conversion</th><th>Form</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {pages.map(p=>(
                <tr key={p.id}>
                  <td style={{ fontWeight:500 }}>{p.name}</td>
                  <td style={{ color:'var(--text-muted)', fontSize:12 }}>{p.template}</td>
                  <td style={{ fontSize:11 }}>{p.url !== '—' ? <a href="#" style={{ color:'var(--accent)' }}>{p.url}</a> : '—'}</td>
                  <td>{p.views.toLocaleString()}</td>
                  <td style={{ color:'var(--accent)', fontWeight:600 }}>{p.submissions}</td>
                  <td style={{ fontWeight:600 }}>{p.conversion}</td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{p.form}</td>
                  <td><span className={statusBadge(p.status)}>{p.status}</span></td>
                  <td style={{ display:'flex', gap:4 }}>
                    {p.status === 'Draft' && <button className="btn btn-primary" style={{ fontSize:11, padding:'4px 10px' }} onClick={()=>publish(p.id)}>Publish</button>}
                    <button className="btn btn-ghost" style={{ fontSize:11, padding:'4px 10px' }} onClick={()=>toast?.('Page editor opening...')}>Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
